import PropTypes from "prop-types"
import React from "react"
import scroll from "scroll"
import scrollDoc from "scroll-doc"
import styled from "styled-components"

import { Box, Flex } from "components/common"
import withHistory from "hoc/with-history"

const Item = styled(Box)`
  cursor: pointer;
  width: 100%;
  ${props =>
    props.column &&
    `
    width: ${Math.ceil(100 / props.column[0] - 1)}%;
    ${props.theme.mediaQueries.tablet`
      width: ${Math.ceil(100 / props.column[1] - 1)}%;
      padding: 10px;
    `}
  `};
`
const Category = styled.img`
  padding: 6px;
  width: 100%;
`

const to_anchor = (id, push) => {
  if (id.startsWith("#")) {
    // anchor
    const page = scrollDoc()
    const top = document.querySelector(id).offsetTop
    scroll.top(page, top)
  }
  if (id.startsWith("/")) {
    // link
    push(id)
  }
}

const LandingCategories = ({ element, push }) => (
  <Box contain textAlign="center">
    <Flex flexWrap="wrap" gutter={{ _: "4px", tablet: 1 }}>
      {element.category_images.map((img, index) => (
        <Item
          column={
            element.category_column.length < 1
              ? [2, 3]
              : element.category_column
          }
          key={index}
          onClick={() => to_anchor(element.category_hrefs[index], push)}
        >
          <picture>
            <source
              data-srcset={`${
                sl.config.jewlr_asset_url
              }${`landing/${img}/mobile.jpg`}`}
              media="(max-width: 767px)"
            />
            <source
              data-srcset={`${
                sl.config.jewlr_asset_url
              }${`landing/${img}/mobile.jpg`} 1x, ${
                sl.config.jewlr_asset_url
              }${`landing/${img}/mobile.jpg`} 2x`}
              media="(min-width: 768px) and (max-width: 1023px)"
            />
            <source
              data-srcset={`${
                sl.config.jewlr_asset_url
              }${`landing/${img}/desktop.jpg`} 1x, ${
                sl.config.jewlr_asset_url
              }${`landing/${img}/desktop_2x.jpg`} 2x`}
              media="(min-width: 1024)"
            />
            <Category
              className="lazyload"
              data-src={`${
                sl.config.jewlr_asset_url
              }${`landing/${img}/desktop_2x.jpg`}`}
              src={require("images/icons/jewlr.gif")}
            />
          </picture>
        </Item>
      ))}
    </Flex>
  </Box>
)

LandingCategories.propTypes = {
  element: PropTypes.object,
  push: PropTypes.func
}

export default withHistory(LandingCategories)
